var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-4 space-y-2 pb-2 text-xs font-bold"},[_c('div',{staticClass:"flex space-x-2"},[_c('favorite-button',{attrs:{"code":_vm.item.code}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }